import { ControlModelInterface, InputType } from "@mv-types";
import { LoginForm } from "../constants";
const LoginModel: ControlModelInterface = {
	[LoginForm.USERNAME]: {
		elementType: InputType.INPUT,
		itemKey: LoginForm.USERNAME,
		// errorText: LoginForm.USER_NAME_ERROR_TEXT,
		placeholder: LoginForm.USERNAME,
		value: "",
		validations: {
			rules: {
				required: true,
			},
			messages: {
				required: LoginForm.USER_NAME_ERROR_TEXT,
				isEmail: LoginForm.USER_NAME_VALID_ERROR_TEXT,
			},
		},

		valid: {
			isValid: false,
			invalidRule: "",
		},
		className: "itemWidth",
	},
	[LoginForm.PASSWORD]: {
		elementType: InputType.INPUT,
		itemKey: LoginForm.PASSWORD,
		placeholder: LoginForm.PASSWORD_LABEL,
		error: false,
		type: "password",
		value: "",
		validations: {
			rules: {
				required: true,
			},
			messages: {
				required: LoginForm.PASSWORD_ERROR_TEXT,
			},
		},
		valid: {
			isValid: false,
			invalidRule: "",
		},
		className: "itemWidth",
	},
};
export const UserKeys = {
	_: "pwaUser",
	USER_NAME: "username",
	FIRST_NAME: "firstName",
	LAST_NAME: "lastName",
	EMAIL: "email",
	PHONE_NUMBER: "mobile",
	ID: "userId",
	ISNEWUSER: "newUser",
	UTILITY_USER: "utilityUser",
	PROFILE_NAME: "profileName",
	USER_TYPE: "userType",
};
export default LoginModel;
